import { parseSearchString } from 'lib/url/searchUrlUtils'
import { useAppSelector } from 'hooks/reduxHooks'
import { useMemo } from 'react'

/**
 * Resolves the approved trip request id from the search URL (`?approvalRequest=`).
 * Search surfaces only — checkout uses `checkout.cart.approvalRequestId` directly.
 */
function useTripRequestId(): string | undefined {
  const search = useAppSelector(state => state.router.location.search)

  return useMemo(() => parseSearchString(search).approvalRequest, [search])
}

export default useTripRequestId
